export default {
  work_type_label: "Work type",
  work_type_true_value: "Corrective",
  work_type_false_value: "Regular",

  entity_type_label: "Entity type",
  entity_type_true_value: "Area",
  entity_type_false_value: "Items",
}
